import { createSlice } from "@reduxjs/toolkit";
import { login, logout, refresh } from "./authOperations";
import storage from "redux-persist/lib/storage";
import persistReducer from "redux-persist/es/persistReducer";

const authInitialState = {
  token: null,
  role: null,
  isLoggedIn: false,
  isRefreshing: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState: authInitialState,
  extraReducers: (builder) => {
    builder
      .addCase(login.fulfilled, (state, action) => {
        state.token = action.payload.token;
        state.role = action.payload.role;
        state.isLoggedIn = true;
      })
      .addCase(logout.fulfilled, (state) => {
        state.token = null;
        state.isLoggedIn = false;
      })
      .addCase(refresh.pending, (state) => {
        state.isRefreshing = true;
      })
      .addCase(refresh.fulfilled, (state, action) => {
        state.user = action.payload;
        state.isLoggedIn = true;
        state.role = action.payload.role;
        state.isRefreshing = false;
      })
      .addCase(refresh.rejected, (state) => {
        state.isRefreshing = false;
      });
  },
});

const authPersistConfig = {
  key: "auth",
  storage,
  whitelist: ["token"],
};

// export const authReduser = authSlice.reducer;
export const authReducer = persistReducer(authPersistConfig, authSlice.reducer);
